import React from 'react';

const TermsOfService = () => {
  return (
    <div className="legal-page" style={{ maxWidth: 900, margin: '20px auto', padding: '16px' }}>
      <h1>Terms of Service</h1>
      <p><strong>Effective date:</strong> March 19, 2026</p>
      <p>
        By using DashBasket services (DashBasket, Dash Resto, Dash Driver), you agree to these terms.
      </p>

      <h2>Use of service</h2>
      <ul>
        <li>You must provide accurate account information.</li>
        <li>You are responsible for activity under your account.</li>
        <li>You must not misuse or attempt to disrupt the service.</li>
      </ul>

      <h2>Orders and delivery</h2>
      <ul>
        <li>Order availability, delivery time, and pricing may vary by location and restaurant.</li>
        <li>Restaurants and drivers are expected to keep information accurate and up to date.</li>
      </ul>

      <h2>Liability</h2>
      <p>
        Services are provided on an as-available basis. To the extent allowed by law, liability is limited.
      </p>

      <h2>Contact</h2>
      <p>Email: sotairekwizera@gmail.com</p>
    </div>
  );
};

export default TermsOfService;
